import useListPageSearchParams from '@/hooks/useListPageSearchParams';
import { ArticleStatus } from '@/axios/company';
import CompanyDetail from '../Company/components/Detail';
import ArticleList from '../Company/components/Article/List';
import { EPublishStatus } from '@/constants/geo';

const articleStatusValues = new Set(Object.values(ArticleStatus));
const articlePublishStatusValues = new Set(Object.values(EPublishStatus));
const getOptionalString = (value: string | null) => {
  if (value === null || value === '') {
    return null;
  }
  return value;
};
const getOptionalNonNegativeNumber = (value: string | null) => {
  if (value === null || value === '') {
    return null;
  }
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed < 0) {
    return null;
  }
  return parsed;
};
const getOptionalNonNegativeInteger = (value: string | null) => {
  const parsed = getOptionalNonNegativeNumber(value);
  return parsed === null ? null : Math.trunc(parsed);
};
const getOptionalNumberArray = (value: string | null) => {
  if (!value) {
    return [];
  }
  return value
    .split(',')
    .map((item) => Number(item))
    .filter((item) => Number.isFinite(item));
};
const getOptionalStringArray = (value: string | null) => {
  if (!value) {
    return [];
  }
  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

const ArticleListPage = () => {
  const { detailId: companyId, listParams, updateListParams, buildDetailUrl, clearDetailParam } = useListPageSearchParams({
    path: '/articles',
    createParams: ({ pageIndex, pageSize, search }, searchParams) => {
      const rawStatus = searchParams.get('status');
      const rawPublishStatus = searchParams.get('publishStatus');
      const status = rawStatus
        ? rawStatus
            .split(',')
            .filter((value): value is ArticleStatus => articleStatusValues.has(value as ArticleStatus))
        : [];
      const publishStatus = rawPublishStatus
        ? rawPublishStatus
            .split(',')
            .filter((value): value is EPublishStatus => articlePublishStatusValues.has(value as EPublishStatus))
        : [];
      return {
        pageIndex,
        pageSize,
        companyId: '',
        search,
        status,
        publishStatus,
        mediaIds: getOptionalNumberArray(searchParams.get('mediaIds')),
        mediaNames: getOptionalStringArray(searchParams.get('mediaNames')),
        priceMin: getOptionalNonNegativeInteger(searchParams.get('priceMin')),
        priceMax: getOptionalNonNegativeInteger(searchParams.get('priceMax')),
        referenceCountMin: getOptionalNonNegativeNumber(searchParams.get('referenceCountMin')),
        referenceCountMax: getOptionalNonNegativeNumber(searchParams.get('referenceCountMax')),
        generateTimeStart: getOptionalString(searchParams.get('generateTimeStart')),
        generateTimeEnd: getOptionalString(searchParams.get('generateTimeEnd')),
      };
    },
  });

  return (
    <>
      {companyId && (
        <div>
          <CompanyDetail
            onReturn={() => {
              clearDetailParam();
            }}
          />
        </div>
      )}
      <div
        style={{
          display: companyId ? 'none' : 'block',
        }}
      >
        <ArticleList
          from="all"
          externalParams={listParams}
          onParamsChange={updateListParams}
          buildCompanyDetailUrl={buildDetailUrl}
        />
      </div>
    </>
  );
};
export default ArticleListPage;
